import AxiosInstance from "../config/AxiosInstance";

export interface CompanyBankDetailPayload {
    bankName: string;
    IBAN?: string;
    SWIFT?: string;
    accountNo?: string;
    bankLocation?: string;
}

export const getCompanyBankDetailList = async (
    page: number = 1,
    limit: number = 50,
    searchValue: string = ""
) => {
    try {
        const { data } = await AxiosInstance.get("/api/company-bank-detail/list", {
            params: { page, limit, searchValue },
        });
        return data;
    } catch (error) {
        throw error;
    }
};

export const createCompanyBankDetail = async (payload: CompanyBankDetailPayload) => {
    try {
        const { data } = await AxiosInstance.post("/api/company-bank-detail", payload);
        return data;
    } catch (error) {
        throw error;
    }
};

export const updateCompanyBankDetail = async (
    id: string,
    payload: CompanyBankDetailPayload
) => {
    try {
        const { data } = await AxiosInstance.put("/api/company-bank-detail/" + id, payload);
        return data;
    } catch (error) {
        throw error;
    }
};

export const deleteCompanyBankDetail = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete("/api/company-bank-detail/" + id);
        return data;
    } catch (error) {
        throw error;
    }
};
